import { FC } from 'react';
import { useTheme } from 'styled-components';

import { IMessageProps, MessageTypeEnum } from './helpers';

import { ScMessageContainer } from './styled';

const Message: FC<IMessageProps> = ({ message, type }) => {
  const { warningIcon: WarningIcon, infoIcon: InfoIcon } = useTheme();

  const MAP_TYPE_TO_ICON: Record<MessageTypeEnum, React.ComponentType> = {
    [MessageTypeEnum.Warning]: WarningIcon,
    [MessageTypeEnum.Info]: InfoIcon,
  };

  const Icon = MAP_TYPE_TO_ICON[type];

  return (
    <ScMessageContainer type={type}>
      <div className="icon">
        <Icon />
      </div>
      <p className="message">{message}</p>
    </ScMessageContainer>
  );
};

export const WarningMessage: FC<Pick<IMessageProps, 'message'>> = (props) => {
  return <Message {...props} type={MessageTypeEnum.Warning} />;
};

export const InfoMessage: FC<Pick<IMessageProps, 'message'>> = (props) => {
  return <Message {...props} type={MessageTypeEnum.Info} />;
};
